import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 3AF49B97-A909-4961-9FBB-82C60D7CC773
 * name arrow-up
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-up.svg
 * tags
 * - Arrow 
 */
export const ArrowUpIcon = createSvgIcon(<><path d="M13,20H11V8L5.5,13.5L4.08,12.08L12,4.16L19.92,12.08L18.5,13.5L13,8V20Z" /></>, 'ArrowUpIcon');
export default ArrowUpIcon